import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ChangePersonalFilesComponent } from './change-personal-files';

export const ChangePersonalFilesModule: string = ng
    .module('archiSmall.userSettings.changePersonalFilesModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('changePersonalFilesComponent', ChangePersonalFilesComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/change-personal-files/change-personal-files.module.ts